// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__QWGMG","clinicsSelect":"TableHeading_clinicsSelect__2iV32"};